/** Authored Hero Forge reference port from fable-rogue 03a219c0
 * tools/character-builder/src/. Numerical keyframes/curves are preserved.
 * See PROVENANCE.md for the explicit skeletal adapter boundary. */
export const DUMMY_MIDDLE=0.48;
